import React from 'react';
import { InitialQuotationTable } from './ordering_quotation_table';
import { QuotationInfo } from '../../budget/components/quotation_info';
import { CheckCircle2, Circle, Minimize2, Maximize2 } from 'lucide-react';

const CATEGORIES = ['Appliances', 'Transport', 'Stone'];

export const InitialQuotationMaker = ({ onTotalChange, onDataChange, details, setDetails, toggleFullScreen, isFullScreen, stockSelections }) => {
  const handleDetailChange = (field, value) => {
    setDetails(prev => ({ ...prev, [field]: value }));
  };

  const handleTotalAmountChange = (amount) => {
    if (onTotalChange) {
      onTotalChange(amount);
    }
  };

  return (
    <div className="w-full h-full flex flex-col mt-4">
      <div className="flex items-center justify-between mb-6 px-1">
        <div className="flex items-center gap-6">
          {CATEGORIES.map(cat => (
            <div
              key={cat}
              className="flex items-center gap-2 cursor-pointer group"
              onClick={() => handleDetailChange('category', cat)}
            >
              {details?.category === cat ? (
                <CheckCircle2 className="text-emerald-600" size={20} />
              ) : (
                <Circle className="text-slate-300 group-hover:text-slate-400 transition-colors" size={20} />
              )}
              <span className={`text-sm font-medium ${details?.category === cat ? 'text-slate-800' : 'text-slate-500 group-hover:text-slate-700'}`}>
                {cat}
              </span>
            </div>
          ))}
        </div>
        {/* Fullscreen button rendered natively inside the normal scroll flow! */}
        {toggleFullScreen && (
          <button
            onClick={toggleFullScreen}
            className="p-1.5 bg-transparent rounded-md text-slate-400 hover:text-brand-blue hover:bg-slate-100 transition-colors"
            title={isFullScreen ? "Exit Fullscreen" : "Enter Fullscreen"}
          >
            {isFullScreen ? <Minimize2 size={16} /> : <Maximize2 size={16} />}
          </button>
        )}
      </div>

      <QuotationInfo details={details} onChange={handleDetailChange} />

      {/* Main Content Area */}
      <div className="flex-1 w-full mt-4">
        <InitialQuotationTable onTotalChange={handleTotalAmountChange} onDataChange={onDataChange} stockSelections={stockSelections} />
      </div>
    </div>
  );
};
